export default __webpack_public_path__ + "static/media/Effra.16903bd5.ttf";